webpackJsonp([10396100530238],{

/***/ 211:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var TutorialsVideos = {
	  ZOCESPdEYo0: {
	    id: "ZOCESPdEYo0",
	    title: "Yubikey Log In (New & Existing Users)",
	    description: "A guide to logging in to Caseworker using a Yubikey as a new or existing user."
	  },
	  "6DsNkh0QLsg": {
	    id: "6DsNkh0QLsg",
	    title: "Transferring email from Outlook to Caseworker",
	    description: "A step by step guide to creating Outlook rules to move emails into your Caseworker inbox."
	  },
	  Yrcncm6Oa8w: {
	    id: "Yrcncm6Oa8w",
	    title: "The Caseworker Inbox",
	    description: "A guide to your Caseworker Inbox covering how to manage casework and campaign emails, and the creation of new constituents and cases from your emails."
	  },
	  wisN0J1qhRM: {
	    id: "wisN0J1qhRM",
	    title: "Creating a New Constituent And Case",
	    description: "A guide to help you create new constiuents in Caseworker when there is not an electoral roll match, and then creating a case for that constituent."
	  },
	  at0Fxr4Mvcw: {
	    id: "at0Fxr4Mvcw",
	    title: "Search Box",
	    description: "A guide to using the Search Box in Caseworker covering how to search for full names, addresses and case references."
	  },
	  "5YjqwSUi224": {
	    id: "5YjqwSUi224",
	    title: "Case Page",
	    description: "A guide to your Caseworker case page covering how to send emails, create letters and adding notes."
	  },
	  Na_kiidYens: {
	    id: "Na_kiidYens",
	    title: "Cases Tab",
	    description: "A guide to your Caseworker cases tab covering how to search for cases, export a mailing list, send a bulk email and add a note en masse."
	  },
	  "t-ZqDbdDyJk": {
	    id: "t-ZqDbdDyJk",
	    title: "Third Party Contacts",
	    description: "A guide to your Caseworker contacts covering how to create organisations and contacts within them."
	  },
	  "3xY8hJC_GAE": {
	    id: "3xY8hJC_GAE",
	    title: "Tools Section",
	    description: "A guide to some of the advanced features within the Caseworker tools section including email templates, door knocking sheets, surgeries and users."
	  },
	  D7U9tV5Kt0k: {
	    id: "D7U9tV5Kt0k",
	    title: "Statistics",
	    description: "An explanation of the statistics page inside your Caseworker installation and how you can use it to monitor what your constituents have contacted you about, the current status of your work, and staff workloads."
	  }
	};
	
	exports.default = TutorialsVideos;
	module.exports = exports["default"];

/***/ }),

/***/ 226:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Grid = __webpack_require__(5);
	
	var _ContentBlock = __webpack_require__(6);
	
	var _ContentBlock2 = _interopRequireDefault(_ContentBlock);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TextSection = __webpack_require__(7);
	
	var _TextSection2 = _interopRequireDefault(_TextSection);
	
	var _Video = __webpack_require__(50);
	
	var _Video2 = _interopRequireDefault(_Video);
	
	var _reactJss = __webpack_require__(3);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	var _tutorialsVideos = __webpack_require__(211);
	
	var _tutorialsVideos2 = _interopRequireDefault(_tutorialsVideos);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles() {
	  return {
	    page: {
	      height: "100vh",
	      // Mobile portrait
	      "@media (min-width: 320px) and (max-width: 667px)": {
	        height: "150vh"
	      },
	      // Mobile landscape and ipad
	      "@media (min-width: 568px) and (max-width: 823px)": {
	        height: "250vh"
	      },
	      // Ipad portrait
	      "@media (min-width: 768px) and (max-width: 769px)": {
	        height: "150vh"
	      },
	      // Ipad pro portrait
	      "@media (min-width: 1024px) and (max-width: 1025px)": {
	        height: "80vh"
	      }
	    },
	    container: {
	      width: "100%",
	      height: "100%"
	    },
	    notMobile: {
	      "@media (max-width: 823px)": {
	        display: "none"
	      }
	    },
	    mobile: {
	      width: "100%",
	      height: "100%",
	      "@media (min-width: 824px)": {
	        display: "none"
	      }
	    },
	    pageTitle: {
	      fontSize: "5.4rem",
	      paddingLeft: "5rem",
	      fontWeight: 100,
	      marginTop: "1rem",
	      marginBottom: "2rem",
	      "@media (max-width: 823px)": {
	        fontSize: "3rem",
	        padding: 0,
	        textAlign: "center",
	        margin: 0
	      }
	    },
	    videoDescription: {
	      fontSize: "1.3rem",
	      color: "#444",
	      maxWidth: "40vw",
	      marginTop: "1rem",
	      "@media (max-width: 823px)": {
	        marginBottom: "1rem",
	        maxWidth: "80vw"
	      }
	    },
	    videoTitle: {
	      fontSize: "30px",
	      marginBottom: "1rem",
	      "@media (max-width: 823px)": {
	        fontSize: "2rem",
	        padding: 0,
	        textAlign: "center"
	      }
	    },
	    listContainer: {
	      height: "50vh",
	      borderLeft: "solid 1px #bbb",
	      maxWidth: "360px",
	      overflowY: "scroll",
	      overflowX: "hidden",
	      marginLeft: "30px",
	      "@media (max-width: 823px)": {
	        border: "none",
	        padding: 0,
	        margin: 0,
	        height: "70vh"
	      }
	    },
	    listLinks: {
	      color: "#666",
	      textDecoration: "none",
	      verticalAlign: "middle",
	      textAlign: "left"
	    },
	    listItems: {
	      display: "flex",
	      alignItems: "center",
	      padding: "0.75rem",
	      borderBottom: "solid 1px #d2d7de",
	      "@media (max-width: 823px)": {
	        paddingLeft: 0,
	        marginLeft: 0
	      }
	    },
	    thumbnails: {
	      paddingRight: "1.125rem",
	      maxWidth: "84px"
	    },
	    video: {
	      width: "45vw",
	      height: "35vh",
	      "@media (max-width: 823px)": {
	        display: "none"
	      },
	      // Ipad pro portrait
	      "@media (max-width: 1024px) and (max-height: 1366px)": {
	        height: "300px"
	      }
	    },
	    videoMobile: {
	      width: "90vw",
	      height: "28vh",
	      "@media (min-width: 667px) and (max-width: 823px)": {
	        height: "90vh"
	      },
	      // Iphone 5 landscape
	      "@media (min-width: 568px) and (max-width: 640px)": {
	        height: "90vh"
	      },
	      "@media (min-width: 767px) and (max-width: 769px)": {
	        height: "40vh"
	      },
	      "@media (min-width: 824px)": {
	        display: "none"
	      }
	    }
	  };
	};
	
	var TutorialsPage = function TutorialsPage(_ref) {
	  var classes = _ref.classes,
	      location = _ref.location;
	
	  var videoId = location.search === "" ? Object.keys(_tutorialsVideos2.default).map(function (v) {
	    return _tutorialsVideos2.default[v];
	  })[0].id : location.search.split("=")[1];
	  return _react2.default.createElement(
	    _ContentBlock2.default,
	    { className: classes.page },
	    _react2.default.createElement(
	      "div",
	      { className: classes.container },
	      _react2.default.createElement(
	        _TextSection2.default,
	        { className: classes.pageTitle },
	        "Tutorials"
	      ),
	      _react2.default.createElement("br", null),
	      _react2.default.createElement(
	        "div",
	        { className: classes.notMobile },
	        _react2.default.createElement(
	          _Grid.Row,
	          { center: true },
	          _react2.default.createElement(
	            _Grid.Col,
	            null,
	            _react2.default.createElement(
	              _TextSection2.default,
	              { className: classes.videoTitle },
	              _tutorialsVideos2.default[videoId].title
	            ),
	            _react2.default.createElement(_Video2.default, {
	              className: classes.video,
	              src: "//www.youtube.com/embed/" + _tutorialsVideos2.default[videoId].id + "?rel=0&amp;showinfo=0"
	            }),
	            _react2.default.createElement(
	              "div",
	              { className: classes.videoDescription },
	              _tutorialsVideos2.default[videoId].description
	            )
	          ),
	          _react2.default.createElement(
	            _Grid.Col,
	            { center: true },
	            _react2.default.createElement(
	              "div",
	              { className: classes.listContainer },
	              _react2.default.createElement(
	                "ul",
	                null,
	                Object.keys(_tutorialsVideos2.default).map(function (v) {
	                  return _tutorialsVideos2.default[v];
	                }).map(function (video) {
	                  return _react2.default.createElement(
	                    "li",
	                    { className: classes.listItems, key: video.id },
	                    _react2.default.createElement(
	                      "a",
	                      {
	                        className: classes.listLinks,
	                        href: "/tutorials/index.html?video=" + video.id
	                      },
	                      _react2.default.createElement("img", {
	                        className: classes.thumbnails,
	                        alt: "Video Thumbmail",
	                        src: "//img.youtube.com/vi/" + video.id + "/mqdefault.jpg"
	                      }),
	                      video.title
	                    )
	                  );
	                })
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: classes.mobile },
	        _react2.default.createElement(
	          _Grid.Col,
	          { center: true, middle: true },
	          _react2.default.createElement(
	            _TextSection2.default,
	            { className: classes.videoTitle },
	            _tutorialsVideos2.default[videoId].title
	          ),
	          _react2.default.createElement(_Video2.default, {
	            className: classes.videoMobile,
	            src: "//www.youtube.com/embed/" + _tutorialsVideos2.default[videoId].id + "?rel=0&amp;showinfo=0"
	          }),
	          _react2.default.createElement(
	            "div",
	            { className: classes.videoDescription },
	            _tutorialsVideos2.default[videoId].description
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: classes.listContainer },
	            _react2.default.createElement(
	              "ul",
	              null,
	              Object.keys(_tutorialsVideos2.default).map(function (v) {
	                return _tutorialsVideos2.default[v];
	              }).map(function (video) {
	                return _react2.default.createElement(
	                  "li",
	                  { className: classes.listItems, key: video.id },
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      className: classes.listLinks,
	                      href: "?video=" + video.id
	                    },
	                    _react2.default.createElement("img", {
	                      className: classes.thumbnails,
	                      alt: "Video Thumbmail",
	                      src: "//img.youtube.com/vi/" + video.id + "/mqdefault.jpg"
	                    }),
	                    video.title
	                  )
	                );
	              })
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	TutorialsPage.propTypes = {
	  classes: _propTypes2.default.object,
	  location: _propTypes2.default.object
	};
	
	exports.default = (0, _reactJss2.default)(styles)(TutorialsPage);
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-tutorials-jsx-b8aaf54676c4fe77ff50.js